module.exports = __webpack_public_path__ + "files/7500de98a5fe39d32b3ad51b9c28cde0.png";